<template>
  <div class="animated fadeIn">
    <MainChartTable  :set_data=set_data :selectedData=ctr />
  </div>
</template>
<script>
import MainChartTable from '../MainChartTable'
export default {
    name: 'Ctr',
    props:[ 'setData'],
    components:{
        MainChartTable
    },
    data () {
        return {
            set_data:0,
            ctr:'ctrs',
        }
    },
    watch :{
        setData(nValue,oValue){
            this.set_data++
            this.ctr='ctrs'
        }
    }
}
</script>
